export default "__VITE_ASSET__LwDCOrSk__"